@if (!(loading | async)) {
  <form [formGroup]="claimContactForm" (ngSubmit)="submitClaimContact()">
    <section formGroupName="contactInfo">
      <div class="row">
        <div class="column twelve pad-bottom-10">
          <h4
            class="heading-sub-section"
            dsContent
            [contentPath]="'claims.fnol.aboutTheIncident'"
          ></h4>
        </div>
        <div class="column twelve md-eight">
          <ds-form-control-container
            labelText="Briefly describe what happened"
            [control]="contactGroup.get('whatHappened')"
          >
            <textarea
              id="whatHappened"
              class="fill"
              formControlName="whatHappened"
              rows="6"
              data-cy="whatHappened"
            ></textarea>
            <ds-form-character-counter
              [maxLength]="250"
              [control]="contactGroup.get('whatHappened')"
            ></ds-form-character-counter>
            <ds-form-control-message
              [control]="contactGroup.get('whatHappened')"
            ></ds-form-control-message>
          </ds-form-control-container>
        </div>
      </div>
      <div class="row">
        <div class="column twelve pad-top-40 pad-bottom-10">
          <h4
            class="heading-sub-section"
            dsContent
            [contentPath]="'claims.fnol.howCanWeReachYou'"
          ></h4>
        </div>
        <div class="column twelve md-four md-pad-right-20">
          <ds-form-control-container
            labelText="Email Address"
            [control]="contactGroup.get('emailAddress')"
          >
            <input
              type="text"
              id="emailAddress"
              class="fill"
              data-cy="emailAddress"
              formControlName="emailAddress"
              data-cy="emailAddress"
            />
            <ds-form-control-message
              [control]="contactGroup.get('emailAddress')"
            ></ds-form-control-message>
          </ds-form-control-container>
        </div>
        <div class="column twelve md-four">
          <ds-form-control-container
            labelText="Phone Number"
            [control]="contactGroup.get('phoneNumber')"
          >
            <input
              [identifier]="'phoneNumber'"
              id="phoneNumber"
              data-cy="phoneNumber"
              [preValue]="contactGroup.value.phoneNumber"
              [phoneControl]="contactGroup.controls['phoneNumber']"
              formControlName="phoneNumber"
              maxlength="12"
              dsPhoneMask
              data-cy="phoneNumber"
            />
            <ds-form-control-message
              [control]="contactGroup.get('phoneNumber')"
            ></ds-form-control-message>
          </ds-form-control-container>
        </div>
      </div>
      <div class="row callToAction">
        <div class="column twelve">
          <a
            href="javascript:void(0)"
            (click)="goBackOneStep()"
            class="float-right md-float-left caption"
            ><i class="icon-chevron-left"></i> Back</a
          >
          <span class="md-float-right">
            <a
              class="pad-horizontal-20"
              (click)="cancel()"
              dsContent
              [contentPath]="'shared.cancel'"
            ></a>
            <button
              ds-button
              type="submit"
              data-cy="primaryButton"
              [disabled]="claimContactForm.invalid"
            >
              {{
                !!this.draftClaim && !!this.draftClaim?.fnolDetail?.whatHappened
                  ? 'Update'
                  : 'Save and Continue'
              }}
            </button>
          </span>
        </div>
      </div>
    </section>
  </form>
}
